
import app from './../index';

export default class KontaktController {

  constructor($scope) {
    this.scope = $scope;
    this.kontakt = app.kontakt;
  }

  submit() {
    this.scope.$broadcast('show-errors-check-validity');

    if (this.scope.form.$invalid) {
      return;
    }

    app.api.kontakte.save(this.kontakt, () => {
      app.kontakt = this.kontakt;
      window.location.href = "/";
      window.toastr.info("Ihre Kontaktdaten wurden gespeichert");
    });
  }
}

KontaktController.$inject = ['$scope'];



/** WEBPACK FOOTER **
 ** ./public/app/kontakt/KontaktController.js
 **/